import { createFileRoute } from "@tanstack/react-router";
import { RunPage } from "@/features/runpage/RunPage";

export const Route = createFileRoute("/_app/automations/$workflow/runs/$run")({ component: Page });

function Page() {
  const { workflow, run } = Route.useParams();
  return <RunPage workflowId={workflow} runId={run} />;
}
